import { Injectable } from '@angular/core';
import { LoadOptions } from 'devextreme/data';
import { StockMoveDocumentHeaderStatusesService } from '../../stock-move-documents/stock-move-document-header-status/stock-move-document-header-statuses.service';
import { StockMoveOutgoingHeaderHeaderStatus } from './stock-move-outgoing-header-header-status.model';

@Injectable({
  providedIn: 'root'
})
export class StockMoveOutgoingHeaderHeaderStatusesService extends StockMoveDocumentHeaderStatusesService<StockMoveOutgoingHeaderHeaderStatus> {
  public override url: string = 'StockMoveOutgoingHeaderHeaderStatus';
  public override defaultOptions: LoadOptions = {
    expand: ["StatusId"]
  };

}
